export default "__VITE_ASSET__xI8yJvhH__"